import { css } from '@microsoft/fast-element';
import { MainStyles } from '@genesislcap/foundation-header';

export const customHeaderStyles = css`
  ${MainStyles}

  .nav-leftside {
    background-color: transparent;
    margin-left: calc(var(--design-unit) * 5px);
  }

  .nav-listbox .bars-container {
    display: none;
  }

  .nav-button {
    display: none;
  }

  .connection-indicator-container {
    display: none;
  }

  .nav-rightside {
    display: flex;
    margin-right: calc(var(--design-unit)* 12px);
  }

  .logo {
      height: calc(var(--design-unit)* 5px);
      width: calc(var(--design-unit)* 32px);
  }

`;
